import { useEffect, useState } from 'react';

import _ from 'lodash';

import { PANE_RESIZE_THROTTLE_MS } from 'utils/documentPanes';

import { checkIsWideWorkspace } from './utils';

/**
 * Detects a genuine wide-workspace setup so the loan editor can OFFER document side-panes —
 * true multi-monitor (`window.screen.isExtended`, Window Management API, no permission
 * prompt) OR an ultrawide single viewport. Falls back to the viewport-width check where
 * `isExtended` is unsupported. Gates whether the affordance is shown; the live window width
 * separately governs how many panes fit (useDocumentPaneCapacity).
 *
 * @returns {{ isWideWorkspace: boolean }}
 */
export const useWideWorkspace = () => {
  const [isWideWorkspace, setIsWideWorkspace] = useState(checkIsWideWorkspace);

  useEffect(() => {
    const onChange = _.throttle(
      () => setIsWideWorkspace(checkIsWideWorkspace()),
      PANE_RESIZE_THROTTLE_MS,
    );

    const screen = typeof window === 'undefined' ? null : window.screen;
    const isScreenChangeSupported =
      !!screen && 'isExtended' in screen && _.isFunction(screen.addEventListener);

    if (isScreenChangeSupported) {
      screen.addEventListener('change', onChange);
    }

    window.addEventListener('resize', onChange);

    return () => {
      if (isScreenChangeSupported) {
        screen.removeEventListener('change', onChange);
      }

      window.removeEventListener('resize', onChange);
      onChange.cancel();
    };
  }, []);

  return { isWideWorkspace };
};
